// extracted by mini-css-extract-plugin
export default {"container":"K0-z","list":"L0-z"};